import { Focusable, TooltipTrigger } from 'react-aria-components';

import { Box, Group, Stack, Text, Tooltip } from '@ekhodealer/ekho-common/rev';

import Info16 from '@common/components/icons/Info16';

import './StatBox.scss';

interface StatBoxProps {
	title: string;
	detail: string;
	/** Optional tooltip text shown via an info icon next to the title. */
	tooltip?: string;
}

export function StatBox({ title, detail, tooltip }: StatBoxProps) {
	return (
		<Box rounding='12' background='secondary' padding='16' data-component='stat-box'>
			<Stack itemsSpacing='8'>
				<Group itemsSpacing='4' itemsAlignY='center' noWrap>
					<Group.Item>
						<Text size='footnote' weight='semibold' color='secondary'>
							{title}
						</Text>
					</Group.Item>
					{tooltip && (
						<Group.Item>
							<TooltipTrigger delay={60}>
								<Focusable>
									<div data-stat-box-tooltip-trigger>
										<Info16 />
									</div>
								</Focusable>
								<Tooltip>{tooltip}</Tooltip>
							</TooltipTrigger>
						</Group.Item>
					)}
				</Group>
				<Text size='body' weight='semibold'>
					{detail}
				</Text>
			</Stack>
		</Box>
	);
}
